'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SET_BOOKING_FLOW_AUTH_INFO = exports.SET_BOOKING_FLOW_AUTH = exports.SET_SHOULD_SET_BOOKING_FLOW_AUTH = exports.VALIDATION_ERROR = exports.PHONE_CHANGE = exports.BIRTHDATE_YEAR_CHANGE = exports.BIRTHDATE_MONTH_CHANGE = exports.BIRTHDATE_DAY_CHANGE = exports.SEX_CHANGE = exports.PASSWORD_CHANGE = exports.EMAIL_CHANGE = exports.LAST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = exports.TITLE_CHANGE = exports.SET_LIST_ITEM_ACTIVE = exports.SET_SPECIALTY_LIST_ACTIVE = exports.SPECIALIST_CALL = exports.PATIENT_CALL = exports.CREATE_ACCOUNT = exports.AGREE_BUTTON_CLICKED = exports.TOGGLE_SHOW_PASSWORD = exports.SPECIALIST_BUTTON_CLICK = exports.PATIENT_BUTTON_CLICK = exports.BACK = exports.CLOSE = exports.BOOK_APPOINTMENT_SIGN_UP_SELECTED = exports.OPEN = undefined;

var _doctifyUtils = require('doctify-utils');

var OPEN = exports.OPEN = 'SIGN_UP_MODAL:OPEN';

var BOOK_APPOINTMENT_SIGN_UP_SELECTED = exports.BOOK_APPOINTMENT_SIGN_UP_SELECTED = 'SIGN_UP_MODAL:BOOK_APPOINTMENT_SIGN_UP_SELECTED';
var CLOSE = exports.CLOSE = 'SIGN_UP_MODAL:CLOSE';
var BACK = exports.BACK = 'SIGN_UP_MODAL:BACK';
var PATIENT_BUTTON_CLICK = exports.PATIENT_BUTTON_CLICK = 'SIGN_UP_MODAL:PATIENT_BUTTON_CLICK';
var SPECIALIST_BUTTON_CLICK = exports.SPECIALIST_BUTTON_CLICK = 'SIGN_UP_MODAL:SPECIALIST_BUTTON_CLICK';
var TOGGLE_SHOW_PASSWORD = exports.TOGGLE_SHOW_PASSWORD = 'SIGN_UP_MODAL:TOGGLE_SHOW_PASSWORD';
var AGREE_BUTTON_CLICKED = exports.AGREE_BUTTON_CLICKED = 'SIGN_UP_MODAL:AGREE_BUTTON_CLICKED';
var CREATE_ACCOUNT = exports.CREATE_ACCOUNT = 'SIGN_UP_MODAL:CREATE_ACCOUNT';
var PATIENT_CALL = exports.PATIENT_CALL = 'SIGN_UP_MODAL:PATIENT_CALL';
var SPECIALIST_CALL = exports.SPECIALIST_CALL = 'SIGN_UP_MODAL:SPECIALIST_CALL';
var SET_SPECIALTY_LIST_ACTIVE = exports.SET_SPECIALTY_LIST_ACTIVE = 'SIGN_UP_MODAL:SET_SPECIALTY_LIST_ACTIVE';
var SET_LIST_ITEM_ACTIVE = exports.SET_LIST_ITEM_ACTIVE = 'SIGN_UP_MODAL:SET_LIST_ITEM_ACTIVE';
var TITLE_CHANGE = exports.TITLE_CHANGE = 'SIGN_UP_MODAL:TITLE_CHANGE';
var FIRST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = 'SIGN_UP_MODAL:FIRST_NAME_CHANGE';
var LAST_NAME_CHANGE = exports.LAST_NAME_CHANGE = 'SIGN_UP_MODAL:LAST_NAME_CHANGE';
var EMAIL_CHANGE = exports.EMAIL_CHANGE = 'SIGN_UP_MODAL:EMAIL_CHANGE';
var PASSWORD_CHANGE = exports.PASSWORD_CHANGE = 'SIGN_UP_MODAL:PASSWORD_CHANGE';
var SEX_CHANGE = exports.SEX_CHANGE = 'SIGN_UP_MODAL:SEX_CHANGE';
var BIRTHDATE_DAY_CHANGE = exports.BIRTHDATE_DAY_CHANGE = 'SIGN_UP_MODAL:BIRTHDATE_DAY_CHANGE';
var BIRTHDATE_MONTH_CHANGE = exports.BIRTHDATE_MONTH_CHANGE = 'SIGN_UP_MODAL:BIRTHDATE_MONTH_CHANGE';
var BIRTHDATE_YEAR_CHANGE = exports.BIRTHDATE_YEAR_CHANGE = 'SIGN_UP_MODAL:BIRTHDATE_YEAR_CHANGE';
var PHONE_CHANGE = exports.PHONE_CHANGE = 'SIGN_UP_MODAL:PHONE_CHANGE';
var VALIDATION_ERROR = exports.VALIDATION_ERROR = 'SIGN_UP_MODAL:VALIDATION_ERROR';
var SET_SHOULD_SET_BOOKING_FLOW_AUTH = exports.SET_SHOULD_SET_BOOKING_FLOW_AUTH = 'SIGN_UP_MODAL:SET_SHOULD_SET_BOOKING_FLOW_AUTH';
var SET_BOOKING_FLOW_AUTH = exports.SET_BOOKING_FLOW_AUTH = 'SIGN_UP_MODAL:SET_BOOKING_FLOW_AUTH';
var SET_BOOKING_FLOW_AUTH_INFO = exports.SET_BOOKING_FLOW_AUTH_INFO = 'SIGN_UP_MODAL:SET_BOOKING_FLOW_AUTH_INFO';

var SignUpModalActions = {
	openSignUpModal: function openSignUpModal() {
		return {
			type: OPEN
		};
	},
	openSignUpModalPatient: function openSignUpModalPatient() {
		return {
			type: BOOK_APPOINTMENT_SIGN_UP_SELECTED
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE
		};
	},
	backButtonClicked: function backButtonClicked() {
		return {
			type: BACK
		};
	},
	patientButtonClicked: function patientButtonClicked() {
		return {
			type: PATIENT_BUTTON_CLICK
		};
	},
	specialistButtonClicked: function specialistButtonClicked() {
		return {
			type: SPECIALIST_BUTTON_CLICK
		};
	},
	toggleShowPassword: function toggleShowPassword() {
		return {
			type: TOGGLE_SHOW_PASSWORD
		};
	},
	agreeButtonClicked: function agreeButtonClicked() {
		return {
			type: AGREE_BUTTON_CLICKED
		};
	},
	createAccount: function createAccount(accountData) {
		return (0, _doctifyUtils.createAction)({
			actionType: CREATE_ACCOUNT,
			url: '/accounts',
			method: 'POST',
			data: accountData,
			keyword: 'account'
		});
	},
	makePatientCall: function makePatientCall(patient) {
		return (0, _doctifyUtils.createAction)({
			actionType: PATIENT_CALL,
			url: '/patients',
			method: 'POST',
			data: patient,
			auth: patient.auth_token
		});
	},
	makeSpecialistCall: function makeSpecialistCall(specialist) {
		return (0, _doctifyUtils.createAction)({
			actionType: SPECIALIST_CALL,
			url: '/specialists',
			method: 'POST',
			data: specialist,
			auth: specialist.auth_token
		});
	},
	setSpecialtyListActive: function setSpecialtyListActive() {
		return {
			type: SET_SPECIALTY_LIST_ACTIVE
		};
	},
	setListItemActive: function setListItemActive(item) {
		return {
			type: SET_LIST_ITEM_ACTIVE,
			item: item
		};
	},
	onTitleChange: function onTitleChange(title) {
		return {
			type: TITLE_CHANGE,
			title: title
		};
	},
	onFirstNameChange: function onFirstNameChange(name) {
		return {
			type: FIRST_NAME_CHANGE,
			name: name
		};
	},
	onLastNameChange: function onLastNameChange(name) {
		return {
			type: LAST_NAME_CHANGE,
			name: name
		};
	},
	onEmailChange: function onEmailChange(email) {
		return {
			type: EMAIL_CHANGE,
			email: email
		};
	},
	onPasswordChange: function onPasswordChange(password) {
		return {
			type: PASSWORD_CHANGE,
			password: password
		};
	},
	onGenderChange: function onGenderChange(gender) {
		return {
			type: SEX_CHANGE,
			gender: gender
		};
	},
	onBirthdateDayChange: function onBirthdateDayChange(day) {
		return {
			type: BIRTHDATE_DAY_CHANGE,
			day: day
		};
	},
	onBirthdateMonthChange: function onBirthdateMonthChange(month) {
		return {
			type: BIRTHDATE_MONTH_CHANGE,
			month: month
		};
	},
	onBirthdateYearChange: function onBirthdateYearChange(year) {
		return {
			type: BIRTHDATE_YEAR_CHANGE,
			year: year
		};
	},
	onPhoneNumberChange: function onPhoneNumberChange(phone) {
		return {
			type: PHONE_CHANGE,
			phone: phone
		};
	},
	validationError: function validationError() {
		return {
			type: VALIDATION_ERROR
		};
	},
	setShouldSetBookingFlowAuthToken: function setShouldSetBookingFlowAuthToken(should) {
		return {
			type: SET_SHOULD_SET_BOOKING_FLOW_AUTH,
			should: should
		};
	},
	setBookingFlowAuthToken: function setBookingFlowAuthToken(token) {
		return {
			type: SET_BOOKING_FLOW_AUTH,
			token: token
		};
	},
	setBookingFlowAuthInfo: function setBookingFlowAuthInfo(info) {
		return {
			type: SET_BOOKING_FLOW_AUTH_INFO,
			info: info
		};
	}
};

exports.default = SignUpModalActions;